import {
  AfterViewInit,
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { InspirationSubNavContainerBaseDirective } from './inspiration-sub-nav-container-base.directive';

@Directive({
  selector: '[idpInspirationSubNavContainer]',
  standalone: true
})
export class InspirationSubNavContainerDirective
  extends InspirationSubNavContainerBaseDirective
  implements AfterViewInit, OnChanges
{
  @Output() appScrolled = new EventEmitter<void>();
  @Input() APP_DISABLE_LEGACY = true;
  @Input() selectedNav = '';

  @HostListener('window:scroll') onWindowScroll(): void {
    if (this.APP_DISABLE_LEGACY) return;

    this.setInspireMenuPosition();

    setTimeout(() => {
      const overlayBackdrop = document.querySelector(
        '.cdk-overlay-backdrop-showing'
      ) as HTMLElement;
      if (overlayBackdrop) return;
      this.appScrolled.emit();
    }, 100);
  }

  @HostListener('document:click', ['$event']) onClick(e: Event): void {
    if (this.APP_DISABLE_LEGACY) return;

    const navLink = e.target as HTMLElement;
    if (navLink && navLink.classList[0].includes('inspiration-sub-nav-link')) {
      this.inspirationSubNavClicked = true;
    } else {
      this.inspirationSubNavClicked = false;
    }
    this.setInspireMenuPosition();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.setInspireMenuPosition();
      this.positionDeltaLogo();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedNav) {
      setTimeout(() => {
        this.setInspireMenuPosition();
      }, 500);
    }
  }

  setInspireMenuPosition(): void {
    this.checkInspireMenu();
    this.inspireSubNavPosition();
  }

  checkInspireMenu(): void {
    if (this.APP_DISABLE_LEGACY) {
      return;
    }
    this.handleSkipContent();
    this.handleInspireMenu();
    this.handleBodyMargin();
    this.isLegacyApp = true;
  }

  handleBodyMargin() {
    this.rend.setStyle(document.body, 'margin', '0');
  }

  handleSkipContent(): void {
    const skipLink = document.querySelector('.skip-content-container a');
    if (skipLink) {
      skipLink.classList.add('skip-main-content');
    }
  }

  handleInspireMenu(): void {
    const inspireMenu = document.body.querySelector(
      '.inspiration-sub-nav-container'
    );
    this.isInspireMenu = !!inspireMenu;
  }

  inspireSubNavPosition(): void {
    if (!this.isInspireMenu) {
      return;
    }

    this.headerHeight = this.calculateTotalHeight();
    this.updateSubNavMargin();
  }

  private positionDeltaLogo(): void {
    if (!this.isInspireMenu) {
      return;
    }
    const inspireSubNav = document.querySelector(
      '.inspiration-sub-nav-container'
    );
    const deltaLogoContainer = document.querySelector('.delta-logo-container');
    if (inspireSubNav && deltaLogoContainer) {
      const totalHeight = this.calculateTotalHeightAboveLogo();
      this.rend.setStyle(
        deltaLogoContainer,
        'margin-top',
        `${totalHeight + 1}px`
      );
    }
  }

  private calculateTotalHeightAboveLogo(): number {
    const alertHeight = this.getElementHeight('.alert-advisory-main-container');
    const navHeight = this.getElementHeight('.header-container');
    const widgetHeight = this.inspirationSubNavClicked
      ? 0
      : this.getElementHeight('.widgets-container');
    const inspireSubNavHeight = this.getElementHeight(
      '.inspiration-sub-nav-container'
    );
    return alertHeight + navHeight + widgetHeight + inspireSubNavHeight;
  }
}
